<script>
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

export default {
  components: { Spinner },
  props: {
    message: { type: String, default: '' },
    isPersistent: { type: Boolean, default: false },
    action: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div>
    <div
      class="shadow-sm bg-slate-800 dark:bg-slate-700 rounded-[4px] items-center gap-3 inline-flex mb-2 max-w-[25rem] min-h-[1.875rem] min-w-[15rem] px-6 py-3 text-left"
    >
      <Spinner v-if="isPersistent" :size="16" class="shrink-0 text-white" />
      <div class="text-sm font-medium text-white dark:text-white">
        {{ message }}
      </div>
      <div v-if="action">
        <router-link
          v-if="action.type == 'link'"
          :to="action.to"
          class="font-medium cursor-pointer select-none text-woot-500 dark:text-woot-500 hover:text-woot-600 dark:hover:text-woot-600"
        >
          {{ action.message }}
        </router-link>
      </div>
    </div>
  </div>
</template>
